import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

import {
  GlobalNavigationBar,
  GlobalNavigationBarRegion,
  GlobalNavigationBarLink,
  GlobalNavigationBarDropdown,
  Button,
  Icon,
  AppLauncher,
  AppLauncherExpandableSection,
  AppLauncherTile,
} from '@salesforce/design-system-react';
import AddHedgeFundModal from '../Modal/addHedgeFund';
import AddStandardUser from '../Modal/addStandarduser';
// import { addNewAccount } from '../../store/accounts/slice';
// import { authSelector } from '../../store/auth/slice';

const hedgeFundOptions = [
  // {
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/overview.svg" alt="overview menu" /> Overview
  //     </span>
  //   ),
  //   value: 'admin/hedge-fund/overview',
  // },
  {
    label: (
      <span>
        <img src="/assets/icons/menus/exchange.svg" alt="exchanges menu" /> Hedge Funds
      </span>
    ),
    value: '/admin/hedge-funds',
    active: true,
  },
  // {
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/overview.svg" alt="overview menu" /> Reports
  //     </span>
  //   ),
  //   value: '/admin/hedge-funds/reports',
  // },
  { type: 'divider' },
  {
    label: (
      <span>
        <img src="/assets/icons/menus/add.svg" alt="add accounts" /> Add Hedge Fund
      </span>
    ),
    value: 'open-add-hedge-fund-user',
  },
];

const subscriptionPlanOptions = [
  {
    label: (
      <span>
        <img src="/assets/icons/menus/users.svg" alt="subscription menu" /> Plans
      </span>
    ),
    value: '/admin/plans',
  },
  // { type: 'divider' },
  // {
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/add.svg" alt="add exchanges" /> Add Plan
  //     </span>
  //   ),
  //   value: 'open-add-standard-user-modal',
  // },
];

const standardUserOptions = [
  // {
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/overview.svg" alt="overview menu" /> Overview
  //     </span>
  //   ),
  //   value: 'admin/standard/overview',
  // },
  {
    label: (
      <span>
        <img src="/assets/icons/menus/users.svg" alt="transactions menu" /> Standard Users
      </span>
    ),
    value: '/admin/standard-users',
  },
  // {
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/overview.svg" alt="overview menu" /> Reports
  //     </span>
  //   ),
  //   value: '/admin/standard/reports',
  // },
  { type: 'divider' },
  {
    label: (
      <span>
        <img src="/assets/icons/menus/add.svg" alt="add exchanges" /> Add Standard User
      </span>
    ),
    value: 'open-add-standard-user-modal',
  },
];

const NavLinks = [
  // { name: 'Home', page: 'home', link: '/admin', isDropdown: false },
  {
    name: 'Hedge Funds',
    page: 'hedge-fund',
    link: '/admin/hedge-funds',
    isDropdown: true,
    options: hedgeFundOptions,
  },
  {
    name: 'Standard Users',
    page: 'standard-user',
    link: '/admin/standard-users',
    isDropdown: true,
    options: standardUserOptions,
  },
  {
    name: 'Subscription Plans',
    page: 'subscription-plans',
    link: '/admin/subscription-plans',
    isDropdown: true,
    options: subscriptionPlanOptions,
  },
  {
    name: 'Sync Monitor',
    page: 'sync-monitor',
    link: '/admin/sync-monitor',
    isDropdown: false,
  },
  // { name: 'Assets', page: 'assets', link: '/admin/assets', isDropdown: false },
  // { name: 'Reports', page: 'reports', link: '/admin/reports', isDropdown: false },
];

const Nav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isActive, setIsActive] = useState('/admin/home');
  const [openAddFundModal, setOpenAddFundModal] = useState(false);
  const [openAddStandardModal, setOpenAddStandardModal] = useState(false);
  const appLauncherRef = useRef();
  // const dispatch = useDispatch();
  // const { user } = useSelector(authSelector);

  function onNavigationClick(value) {
    navigate(`${value}`);
    setIsActive(value);
  }

  const handleDropdownNavigate = (value) => {
    if (value === 'open-add-hedge-fund-user') {
      setOpenAddFundModal(true);
    } else if (value === 'open-add-standard-user-modal') {
      setOpenAddStandardModal(true);
    } else {
      navigate(value);
    }
  };

  // const handleFormSubmit = async (formData) => {
  //   dispatch(addNewAccount(formData));
  // };

  useEffect(() => {
    if (location.pathname === '/') {
      setIsActive('/home');
    } else {
      setIsActive(location.pathname);
    }
  }, [location.pathname]);

  const handleTileClick = (to) => {
    appLauncherRef.current.closeAppLauncher();
    onNavigationClick(to);
  };

  return (
    <div>
      <GlobalNavigationBar>
        {/* <GlobalNavigationBarRegion region="primary">
          <AppLauncher
            id="app-launcher-trigger"
            triggerName="Admin Portal"
            ariaHideApp={false}
            modalHeaderButton={<Button label="App Exchange" />}
          >
            <AppLauncherExpandableSection title="Tile Section">
              <AppLauncherTile
                title="Marketing Cloud"
                iconText="MC"
                description="Send emails, track emails, read emails! Emails!"
              />
              <AppLauncherTile
                title="Call Center"
                description="The key to call center and contact center is not to use too many words!"
                iconText="CC"
              />
            </AppLauncherExpandableSection>
            <AppLauncherExpandableSection title="Small Tile Section">
              <AppLauncherTile title="Journey Builder" iconText="JB" />
              <AppLauncherTile
                title="Sales Cloud"
                iconNode={<Icon name="campaign" category="standard" size="large" />}
              />
            </AppLauncherExpandableSection>
          </AppLauncher>
        </GlobalNavigationBarRegion> */}
        <GlobalNavigationBarRegion region="primary">
          <p className="slds-truncate slds-context-bar__label-action slds-context-bar__app-name">
            {' '}
            Admin Portal
          </p>
        </GlobalNavigationBarRegion>
        <GlobalNavigationBarRegion region="secondary" navigation>
          {NavLinks.map((nl, index) =>
            nl.isDropdown ? (
              <GlobalNavigationBarDropdown
                key={index}
                active={isActive === nl.link ? true : false}
                assistiveText={{ icon: 'Dropdown' }}
                align="left"
                id="dropdown"
                label={nl.name}
                openOn="hover"
                onClick={() => onNavigationClick(nl.link)}
                onSelect={({ value }) => handleDropdownNavigate(value)}
                options={nl.options}
                to={'/defi'}
              />
            ) : (
              <GlobalNavigationBarLink
                key={index}
                active={isActive === nl.link ? true : false}
                label={nl.name}
                to={nl.page}
                onClick={() => onNavigationClick(nl.link)}
                className={`slds-admin-disable`}
              />
            )
          )}
        </GlobalNavigationBarRegion>
      </GlobalNavigationBar>
      <AddHedgeFundModal
        openModal={openAddFundModal}
        closeModal={() => setOpenAddFundModal(false)}
      />
      <AddStandardUser
        openModal={openAddStandardModal}
        closeModal={() => setOpenAddStandardModal(false)}
      />
    </div>
  );
};

export default Nav;
